import { inject, Injectable } from '@angular/core';
import { Data } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { routes, RouteUserRole } from '../app.routes';
import { UserRoles } from '../models/User';
import { UserService } from './user.service';

const ADMIN_ROUTES = new Set(
  routes.filter((route) => route.data?.userRole === RouteUserRole.ADMIN).map((route) => route.data.routerLink)
);
const USER_ROUTES = new Set(
  routes.filter((route) => route.data?.userRole === RouteUserRole.DEFAULT).map((route) => route.data.routerLink)
);

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly userService = inject(UserService);

  public getRoutes(): Observable<Array<Data>> {
    return this.userService.getRoles().pipe(
      take(1),
      map((userRoles: UserRoles) => {
        return routes
          .filter((route) => route.data?.showInNavigation)
          .map((route) => {
            if (ADMIN_ROUTES.has(route.data.routerLink)) {
              return userRoles.isAdmin ? route.data : null;
            }

            if (USER_ROUTES.has(route.data.routerLink)) {
              return userRoles.isNurse || userRoles.isPhysician ? route.data : null;
            }

            return route.data;
          })
          .filter((route) => route !== null);
      })
    );
  }
}
